module.exports = __webpack_public_path__ + "static/me4-lg-7740551e7732a91ec8d717722af3823d.jpg";